var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:_vm.trailerClass},[(!_vm.trailer)?_c('img',{staticClass:"subscribe_icon",attrs:{"src":require("../../../../static/subscribe.svg")}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.trailer ? '已订阅' : '订阅')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }